import React from 'react';

import styles from './styles/content-box.module.css';

export default function ContentBox({ title, content }) {
    return (
        <div className={styles.wrapper}>
            <p className={styles.title}>{title}</p>
            <div>
                {content}
            </div>
            {title === '파일 업로드' &&
                <p className={styles.info}>
                    지원 파일 형식 : pdf, hwp, hwpx, xls, xlsx<br />
                    파일 1개 크기 제한 : 50MB<br />
                    한 번에 업로드 가능한 총 파일 크기 제한 : 500MB
                </p>
            }
        </div>
    );
}
